module.exports = __webpack_public_path__ + "img/widgetcatalog-4.fef4411f.jpg";